<main>
  <!-- Hero -->
  <app-hero></app-hero>

  <section id="features" class="py-10 bg-secondary">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <!-- Feature Card -->
        <div
          class="bg-[#3A3A3C] opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale-200 hover:grayscale-0 p-4 rounded-lg flex items-center space-x-4 shadow"
        >
          <div
            class="w-12 h-12 flex items-center justify-center rounded-full bg-accent-blue/10 text-blue-600"
          >
            <!-- Icon -->
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          </div>
          <div>
            <h3 class="text-base font-semibold text-primary">Smart Access</h3>
            <p class="text-xs text-[#fff] opacity-80 leading-tight">
              Control entries and exits digitally.
            </p>
          </div>
        </div>

        <!-- Repeat for each feature -->
        <div
          class="bg-[#3A3A3C] opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale-200 hover:grayscale-0 p-4 rounded-lg flex items-center space-x-4 shadow"
        >
          <div
            class="w-12 h-12 flex items-center justify-center rounded-full bg-accent-orange/10 text-accent-orange"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </div>
          <div>
            <h3 class="text-base font-semibold text-primary">
              Resident Experience
            </h3>
            <p class="text-xs text-secondary opacity-80 leading-tight">
              Bills, requests & assistance made easy.
            </p>
          </div>
        </div>

        <div
          class="bg-[#3A3A3C] opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale-200 hover:grayscale-0 p-4 rounded-lg flex items-center space-x-4 shadow"
        >
          <div
            class="w-12 h-12 flex items-center justify-center rounded-full bg-accent-green/10 text-accent-green"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.001 12.001 0 002.92 11.65c-.34.78-.34 1.62 0 2.401a12.003 12.003 0 008.618 3.04 12.003 12.003 0 008.618-3.04c.34-.78.34-1.62 0-2.401a12.001 12.001 0 00-3.098-8.606z"
              />
            </svg>
          </div>
          <div>
            <h3 class="text-base font-semibold text-primary">
              Enhanced Security
            </h3>
            <p class="text-xs text-secondary opacity-80 leading-tight">
              Real-time alerts and patrol tools.
            </p>
          </div>
        </div>

        <div
          class="bg-[#3A3A3C] opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale-200 hover:grayscale-0 p-4 rounded-lg flex items-center space-x-4 shadow"
        >
          <div
            class="w-12 h-12 flex items-center justify-center rounded-full bg-accent-blue/10 text-accent-blue"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
              />
            </svg>
          </div>
          <div>
            <h3 class="text-base font-semibold text-primary">
              Central Control
            </h3>
            <p class="text-xs text-secondary opacity-80 leading-tight">
              Unified dashboard management.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- <section id="features" class="py-20 md:py-32 bg-secondary">
    <div class="container mx-auto px-6">
      <h2 class="text-4xl md:text-5xl font-bold text-center mb-5 text-primary">
        Intelligent Solutions for Modern Estates
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-blue/10"
          >
            <svg
              class="w-14 h-14 text-accent-blue"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              ></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">Smart Access</h3>
          <p class="text-secondary opacity-80">
            Digitally control and monitor all entries and exits — from visitors
            to contractors and vendors.
          </p>
        </div>
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-orange/10"
          >
            <svg
              class="w-14 h-14 text-accent-orange"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
              ></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Resident Experience
          </h3>
          <p class="text-secondary opacity-80">
            Simplify daily living with service requests, bill reminders, and
            emergency assistance in one app.
          </p>
        </div>
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-green/10"
          >
            <svg
              class="w-14 h-14 text-accent-green"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.001 12.001 0 002.92 11.65c-.34.78-.34 1.62 0 2.401a12.003 12.003 0 008.618 3.04 12.003 12.003 0 008.618-3.04c.34-.78.34-1.62 0-2.401a12.001 12.001 0 00-3.098-8.606z"
              ></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Enhanced Security
          </h3>
          <p class="text-secondary opacity-80">
            Equip your guards and admins with real-time alerts, patrol logs, and
            visitor verification tools.
          </p>
        </div>
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-blue/10"
          >
            <svg
              class="w-14 h-14 text-accent-blue"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
              ></path>
            </svg>
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Centralized Control
          </h3>
          <p class="text-secondary opacity-80">
            Estate managers get full visibility and control from a unified
            command dashboard.
          </p>
        </div>
      </div>
    </div>
  </section> -->

  <section class="py-20 lg:pb-32 lg:pt-10 bg-primary">
    <div class="lg:px-[55px] px-[20px] mb-10">
      <h1 class="text-blue-600 lg:text-4xl text-2xl font-[700]">The Suite</h1>
    </div>
    <div class="container mx-auto px-6 space-y-32" id="solutions">
      <div
        *ngFor="let item of solutions"
        class="flex flex-col lg:flex-row items-center gap-16 group relative"
        [ngClass]="{
          'lg:flex-row-reverse items-center': item.layout === 'right',
          'items-center': item.layout === 'left'
        }"
        [attr.id]="item.id"
      >
        <div
          class="lg:w-1/2 text-center flex flex-col items-center"
          [ngClass]="item.layout === 'right' ? 'lg:text-right' : 'lg:text-left'"
        >
          <div class="lg:mt-[150px">
            <h2
              class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center sm:text-left mb-4 sm:mb-6 leading-tight tracking-tight"
            >
              <span
                class="bg-gradient-to-r from-white via-[#336799] to-blue-900 bg-clip-text text-transparent"
              >
                {{ item.title }}
              </span>
            </h2>
            <p
              class="text-lg md:text-xl mb-8 text-secondary max-w-2xl lg:max-w-none mx-auto leading-relaxed"
            >
              {{ item.description }}
            </p>
            <button
              (click)="productView(item.id)"
              class="btn-primary mt-10 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
            >
              Learn More
            </button>
          </div>
        </div>

        <div class="lg:w-1/2 lg:h-[500px flex justify-center relative">
          <img
            [src]="item.imageUrl"
            [alt]="item.imageAlt"
            class="rounded-xl shadow-2xl w-full max-w-lg lg:max-w-none h-auto object-fit transform hover:scale-102 transition-transform duration-300 group-hover:scale-102 group-hover:shadow-xl"
          />
        </div>
      </div>
    </div>

    <!-- <div class="container mx-auto px-6 space-y-32" id="solutions">
      <div class="flex flex-col lg:flex-row items-center gap-16 group">
        <div class="lg:w-1/2 text-center lg:text-left">
          <h2
            class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white text-center sm:text-left mb-6 tracking-tight leading-tight"
          >
            <span
              class="bg-gradient-to-r from-white via-[#336799] to-blue-900 bg-clip-text text-transparent"
            >
              Estate360 Community
            </span>
          </h2>

          <p
            class="text-lg md:text-xl mb-8 text-secondary max-w-2xl lg:max-w-none mx-auto leading-relaxed"
          >
            Estate360 Community empowers gated estates with visitor QR codes, a
            dedicated resident app, emergency alert buttons, and a manager
            dashboard — all designed to enhance safety, communication, and
            convenience for modern estate living.
          </p>
          <button
            (click)="productView()"
            class="btn-primary mt-10 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            Learn More
          </button>
        </div>
        <div class="lg:w-1/2 flex justify-center relative">
          <img
            src="https://placehold.co/700x450/E67E22/FFFFFF?text=Estate360+ Community+Illustration"
            alt="Estate360 Community Illustration"
            class="rounded-xl shadow-2xl w-full max-w-lg lg:max-w-none h-auto object-cover border border-border-color transform hover:scale-102 transition-transform duration-300 group-hover:scale-102 group-hover:shadow-xl"
          />
        </div>
      </div>
      <div class="flex flex-col lg:flex-row-reverse items-center gap-16 group">
        <div class="lg:w-1/2 text-center lg:text-right">
          <h2
            class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center sm:text-left mb-4 sm:mb-6 leading-tight tracking-tight"
          >
            <span
              class="bg-gradient-to-r from-white via-[#336799] to-blue-900 bg-clip-text text-transparent"
            >
              Estate360 Homes
            </span>
          </h2>
          <p
            class="text-lg md:text-xl mb-8 text-secondary max-w-2xl lg:max-w-none mx-auto leading-relaxed"
          >
            Estate360 Homes connects buyers, sellers, and agents with verified
            property listings, in-app agent chat, and streamlined move-in
            logistics — making real estate transactions easier and more secure.
          </p>
          <button
            (click)="productView()"
            class="btn-primary mt-10 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            Learn More
          </button>
        </div>
        <div class="lg:w-1/2 flex justify-center relative">
          <img
            src="https://placehold.co/700x450/2ECC71/FFFFFF?text=Estate360+Homes+Illustration"
            alt="Estate360 Homes Illustration"
            class="rounded-xl shadow-2xl w-full max-w-lg lg:max-w-none h-auto object-cover border border-border-color transform hover:scale-102 transition-transform duration-300 group-hover:scale-102 group-hover:shadow-xl"
          />
        </div>
      </div>
      <div class="flex flex-col lg:flex-row-reverse items-center gap-16 group">
        <div class="lg:w-1/2 text-center lg:text-right">
          <h2
            class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center sm:text-left mb-4 sm:mb-6 leading-tight tracking-tight"
          >
            <span
              class="bg-gradient-to-r from-white via-[#336799] to-blue-900 bg-clip-text text-transparent"
            >
              Estate360 Developer
            </span>
          </h2>

          <p
            class="text-lg md:text-xl mb-8 text-secondary max-w-2xl lg:max-w-none mx-auto leading-relaxed"
          >
            Estate360 Developer equips estate builders and project teams with
            daily site updates, synchronized plot sales and construction
            tracking, and real-time workforce monitoring — all in one
            centralized platform.
          </p>
          <button
            (click)="productView()"
            class="btn-primary mt-10 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            Learn More
          </button>
        </div>
        <div class="lg:w-1/2 flex justify-center relative">
          <img
            src="https://placehold.co/700x450/336799/FFFFFF?text=Estate360+Developer+Illustration"
            alt="Estate360 Developer Illustration"
            class="rounded-xl shadow-2xl w-full max-w-lg lg:max-w-none h-auto object-cover border border-border-color transform hover:scale-102 transition-transform duration-300 group-hover:scale-102 group-hover:shadow-xl"
          />
        </div>
      </div>

      <div class="flex flex-col lg:flex-row items-center gap-16 group">
        <div class="lg:w-1/2 text-center lg:text-left">
          <h2
            class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center sm:text-left mb-4 sm:mb-6 leading-tight tracking-tight"
          >
            <span
              class="bg-gradient-to-r from-white via-[#336799] to-blue-900 bg-clip-text text-transparent"
            >
              Estate360 Organization
            </span>
          </h2>
          <p
            class="text-lg md:text-xl mb-8 text-secondary max-w-2xl lg:max-w-none mx-auto leading-relaxed"
          >
            Estate360 Organization offers role-based access, visitor scheduling,
            and seamless sync with estate security — built for offices, schools,
            and hospitals to streamline entry management and enhance safety
            across facilities.
          </p>
          <button
            (click)="productView()"
            class="btn-primary mt-10 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            Learn More
          </button>
        </div>
        <div class="lg:w-1/2 flex justify-center relative">
          <img
            src="https://placehold.co/700x450/E67E22/FFFFFF?text= Estate360+Organization+Illustration"
            alt="Estate360 Organization Illustration"
            class="rounded-xl shadow-2xl w-full max-w-lg lg:max-w-none h-auto object-cover border border-border-color transform hover:scale-102 transition-transform duration-300 group-hover:scale-102 group-hover:shadow-xl"
          />
        </div>
      </div>
    </div> -->
  </section>

  <section class="py-20 md:py-32 bg-secondary">
    <div class="container mx-auto px-6">
      <h2 class="text-3xl md:text-4xl font-bold text-center mb-16 text-primary">
        Trusted by Leading Estates & Partners
      </h2>
      <div
        class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 items-center justify-center"
      >
        <img
          src="https://placehold.co/150x60/3A3A3C/AEAEB2?text=Partner+A"
          alt="Partner Logo A"
          class="mx-auto opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale hover:grayscale-0"
        />
        <img
          src="https://placehold.co/150x60/3A3A3C/AEAEB2?text=Partner+B"
          alt="Partner Logo B"
          class="mx-auto opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale hover:grayscale-0"
        />
        <img
          src="https://placehold.co/150x60/3A3A3C/AEAEB2?text=Partner+C"
          alt="Partner Logo C"
          class="mx-auto opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale hover:grayscale-0"
        />
        <img
          src="https://placehold.co/150x60/3A3A3C/AEAEB2?text=Partner+D"
          alt="Partner Logo D"
          class="mx-auto opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale hover:grayscale-0"
        />
        <img
          src="https://placehold.co/150x60/3A3A3C/AEAEB2?text=Partner+E"
          alt="Partner Logo E"
          class="mx-auto opacity-70 hover:opacity-100 transition-opacity duration-300 filter grayscale hover:grayscale-0"
        />
      </div>
    </div>
  </section>

  <section class="py-20 md:py-32 bg-primary">
    <div class="container mx-auto px-6">
      <h2 class="text-4xl md:text-5xl font-bold text-center mb-16 text-primary">
        What Our Residents Say
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          class="bg-card p-8 rounded-xl shadow-lg flex flex-col items-center text-center border border-border-color"
        >
          <img
            src="https://placehold.co/80x80/2C2C2E/AEAEB2?text=User"
            alt="User Avatar"
            class="rounded-full w-20 h-20 mb-6 object-cover"
          />
          <p class="text-lg italic mb-4 text-primary">
            "Estate360Hub has revolutionized our community. Visitor management
            is a breeze, and paying bills is so easy now!"
          </p>
          <p class="font-semibold text-primary">- Aisha K.</p>
          <p class="text-sm text-secondary">Resident, Harmony Estate</p>
        </div>
        <div
          class="bg-card p-8 rounded-xl shadow-lg flex flex-col items-center text-center border border-border-color"
        >
          <img
            src="https://placehold.co/80x80/2C2C2E/AEAEB2?text=User"
            alt="User Avatar"
            class="rounded-full w-20 h-20 mb-6 object-cover"
          />
          <p class="text-lg italic mb-4 text-primary">
            "The admin dashboard gives us unprecedented control. We've seen a
            significant improvement in efficiency and security."
          </p>
          <p class="font-semibold text-primary">- Mr. Obi</p>
          <p class="text-sm text-secondary">
            Estate Manager, Grandview Gardens
          </p>
        </div>
        <div
          class="bg-card p-8 rounded-xl shadow-lg flex flex-col items-center text-center border border-border-color"
        >
          <img
            src="https://placehold.co/80x80/2C2C2E/AEAEB2?text=User"
            alt="User Avatar"
            class="rounded-full w-20 h-20 mb-6 object-cover"
          />
          <p class="text-lg italic mb-4 text-primary">
            "Emergency alerts and patrol tracking have made our estate feel much
            safer. Highly recommend Estate360Hub!"
          </p>
          <p class="font-semibold text-primary">- Chidi E.</p>
          <p class="text-sm text-secondary">Resident, Serenity Hills</p>
        </div>
      </div>
    </div>
  </section>

  <section class="py-20 md:py-32 bg-secondary text-white">
    <div class="container mx-auto px-6 text-center">
      <h2 class="text-4xl md:text-6xl font-extrabold leading-tight mb-8">
        Ready to Transform Your Estate?
      </h2>
      <p
        class="text-lg md:text-xl max-w-3xl mx-auto mb-12 text-secondary opacity-90"
      >
        Join leading estates across Africa who trust Estate360Hub’s intelligent
        solutions to power the future of gated living.
      </p>
      <div
        class="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
      >
        <button
          class="btn-primary px-10 py-4 rounded-full text-xl font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
        >
          Request a Demo
        </button>
        <button
          class="border-2 border-white text-white px-10 py-4 rounded-full text-xl font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 hover:bg-white hover:text-accent-blue"
        >
          Contact Sales
        </button>
      </div>
    </div>
  </section>
</main>
